import { Component } from '@angular/core';

@Component({
  selector: 'card-item-skeleton',
  templateUrl: './card-item-skeleton.component.html',
  styleUrls: ['./card-item-skeleton.component.scss'],
})
export class CardItemSkeletonComponent {}
